module.exports = __webpack_public_path__ + "img/institucion.1f4b0f62.png";